import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Tabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';
import EmojiFrequentIcon from '@atlaskit/icon/glyph/emoji/frequent';
import QueuesIcon from '@atlaskit/icon/glyph/queues';
import TeamsIcon from '@atlaskit/icon/glyph/teams';
import SuitcaseIcon from '@atlaskit/icon/glyph/suitcase';

import RevisionLogs from '@/components/primitive/revision-logs';
import { textDecorationNone, extendWidth } from '@/styles';
import { Report } from '@/components/primitive';
import { useLocationController } from '@/controllers';

import { PageContentTabsProps } from './types';
import { PageContentTabNames } from './constants';
import * as styles from './styles';

const PageContentTabs: React.FC<PageContentTabsProps> = ({ id, tabName, entityType }) => {
  const { isDashboard, isTeamPage, isProductPage } = useLocationController();
  const isTeamDashboard = isDashboard && isTeamPage;
  const isProductDashboard = isDashboard && isProductPage;

  let selectedIndex: number;
  switch (tabName) {
    case PageContentTabNames.CAPABILITIES:
      selectedIndex = 0;
      break;
    case PageContentTabNames.PRODUCTS:
      selectedIndex = 1;
      break;
    case PageContentTabNames.TEAMS:
      selectedIndex = 1;
      break;
    case PageContentTabNames.HISTORY:
      selectedIndex = isDashboard ? 2 : 1;
      break;
    default:
      selectedIndex = 0;
  }

  const { search } = useLocation();

  return (
    <Tabs selected={selectedIndex} id={`${entityType}-page-content-tabs`}>
      <TabList>
        <Tab>
          <Link
            relative="path"
            to={`/${entityType}/${id}${isDashboard ? '/dashboard' : ''}${search}`}
            css={textDecorationNone}
          >
            <h4 css={styles.tabTitleStyles}>
              <QueuesIcon label="" size="small" />
              Capabilities
            </h4>
          </Link>
        </Tab>
        {isTeamDashboard && (
          <Tab>
            <Link
              relative="path"
              to={`/${entityType}/${id}/dashboard/products${search}`}
              css={textDecorationNone}
            >
              <h4 css={styles.tabTitleStyles}>
                <SuitcaseIcon label="" size="small" />
                Products
              </h4>
            </Link>
          </Tab>
        )}
        {isProductDashboard && (
          <Tab>
            <Link
              relative="path"
              to={`/${entityType}/${id}/dashboard/teams${search}`}
              css={textDecorationNone}
            >
              <h4 css={styles.tabTitleStyles}>
                <TeamsIcon label="" size="small" />
                Teams
              </h4>
            </Link>
          </Tab>
        )}
        <Tab>
          <Link
            relative="path"
            to={`/${entityType}/${id}${isDashboard ? '/dashboard' : ''}/history${search}`}
            css={textDecorationNone}
          >
            <h4 css={styles.tabTitleStyles}>
              <span css={styles.enlargedIconStyles}>
                <EmojiFrequentIcon label="" size="small" />
              </span>
              Change History
            </h4>
          </Link>
        </Tab>
      </TabList>
      <TabPanel>
        <Report type="capability" css={extendWidth} entityType={entityType} isAdvanced />
      </TabPanel>
      {isTeamDashboard && (
        <TabPanel>
          <Report type="product" css={extendWidth} entityType={entityType} isAdvanced />
        </TabPanel>
      )}
      {isProductDashboard && (
        <TabPanel>
          <Report type="team" css={extendWidth} entityType={entityType} isAdvanced />
        </TabPanel>
      )}
      <TabPanel>
        <RevisionLogs entityType={entityType} publicId={id} />
      </TabPanel>
    </Tabs>
  );
};

export default PageContentTabs;
